import React, { useState } from 'react';
import { useAuth } from '../../components/auth/AuthContext';
import { useOFEFetch } from './useOFE';

const STATUS_COLORS = {
  scheduled: 'bg-gray-700 text-gray-300',
  in_transit: 'bg-blue-900/40 text-blue-300',
  delivered: 'bg-green-900/40 text-green-300',
  refused: 'bg-red-900/40 text-red-400',
  damaged: 'bg-orange-900/40 text-orange-400',
};

export default function OFEShipmentTracker() {
  const { user } = useAuth();
  const [statusFilter, setStatusFilter] = useState('');
  const query = statusFilter ? `?status=${statusFilter}` : '';
  const { data: shipments, loading } = useOFEFetch(`/ofe/logistics/shipments${query}`, user, [statusFilter]);

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center gap-4">
        <h1 className="text-xl font-bold text-white">Shipment Tracker</h1>
        <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}
          className="ml-auto bg-gray-800 border border-gray-600 text-white px-3 py-1.5 rounded text-sm">
          <option value="">All statuses</option>
          {Object.keys(STATUS_COLORS).map(s => <option key={s} value={s}>{s.replace(/_/g, ' ')}</option>)}
        </select>
      </div>

      {loading && <div className="text-gray-400">Loading...</div>}

      <div className="bg-gray-800 border border-gray-700 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-900 text-gray-400">
            <tr>
              <th className="text-left px-4 py-3">Shipment #</th>
              <th className="text-left px-4 py-3">Carrier</th>
              <th className="text-left px-4 py-3">Tracking</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-left px-4 py-3">Est. Delivery</th>
              <th className="text-left px-4 py-3">Actual</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-700">
            {(shipments || []).map(s => (
              <tr key={s.id} className="hover:bg-gray-750">
                <td className="px-4 py-3 font-mono text-blue-400 text-xs">{s.shipment_number}</td>
                <td className="px-4 py-3 text-gray-300">{s.carrier || '—'}</td>
                <td className="px-4 py-3 font-mono text-xs text-gray-400">{s.tracking_number || '—'}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs px-2 py-0.5 rounded-full ${STATUS_COLORS[s.status] || 'bg-gray-700 text-gray-300'}`}>
                    {s.status?.replace(/_/g, ' ')}
                  </span>
                </td>
                <td className="px-4 py-3 text-gray-300 text-xs">{s.estimated_delivery || '—'}</td>
                <td className="px-4 py-3 text-xs">
                  {s.actual_delivery ? <span className="text-green-400">✓ {s.actual_delivery}</span> : <span className="text-gray-500">—</span>}
                </td>
              </tr>
            ))}
            {!shipments?.length && !loading && (
              <tr><td colSpan={6} className="px-4 py-8 text-center text-gray-500">No shipments</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
